/**
 * Safely extract a human-readable error message from any API error.
 *
 * FastAPI returns validation errors (HTTP 422) with `detail` as an ARRAY of
 * { loc, msg, type } objects. Passing that array directly to React (e.g. via
 * toast.error) crashes the render tree because React cannot render plain
 * objects as children — symptom: blank/black page.
 *
 * This helper always returns a string, regardless of the shape of `detail`.
 *
 * @param {*} error            The error thrown by axios / fetch.
 * @param {string} fallback    Fallback message when nothing usable is found.
 * @returns {string}
 */
export function extractErrorMessage(error, fallback = 'Ocorreu um erro') {
  const detail = error?.response?.data?.detail;

  if (detail == null) {
    return error?.message || fallback;
  }

  if (typeof detail === 'string') {
    return detail;
  }

  if (Array.isArray(detail)) {
    const parts = detail.map((e) => {
      if (typeof e === 'string') return e;
      const field = Array.isArray(e?.loc) ? e.loc.slice(-1)[0] : '';
      const msg = e?.msg || '';
      return field ? `${field}: ${msg}` : (msg || JSON.stringify(e));
    });
    return parts.filter(Boolean).join(' • ') || fallback;
  }

  if (typeof detail === 'object') {
    return detail.msg || detail.message || JSON.stringify(detail);
  }

  return String(detail);
}

export default extractErrorMessage;
